<template>
  <div class="content">
    <!-- base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0">{{ mode }}</h6>
          <nav aria-label="breadcrumb" class="d-none text-black d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header -->

    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <!-- b-col lg="4">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col -->

        <b-col lg="12">
          <template v-if="mode =='Angebote'">

            <button class="btn btn-primary" @click="retrieveOffers()">
              <i class="fa fa-file"></i>
              Angebote
            </button>

          </template>
          <template v-if="mode !='Angebote'">

            <button class="btn" @click="retrieveOffers()">
              <i class="fa fa-file"></i>
              Angebote
            </button>

          </template>

          <template v-if="mode =='Anträge'">

            <button class="btn btn-primary" @click="retrieveContracts()">
              <i class="fa fa-file"></i>
              Anträge
            </button>

          </template>
          <template v-if="mode !='Anträge'">

            <button class="btn" @click="retrieveContracts()">
              <i class="fa fa-file"></i>
              Anträge
            </button>

          </template>

          <template v-if="mode =='Eingereichte Anträge'">

            <button class="btn btn-primary" @click="retrieveSubmittedContracts()">
              <i class="fa fa-file"></i>
              Eingereichte Anträge
            </button>

          </template>

          <template v-if="mode !='Eingereichte Anträge'">

            <button class="btn" @click="retrieveSubmittedContracts()">
              <i class="fa fa-file"></i>
              Eingereichte Anträge
            </button>

          </template>
        
        </b-col>

      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ mode }}</h3>
            <p class="text-sm mb-0">
              <!-- Nachfolgend finden Sie alle von Ihnen gerechneten Kundenangebote. -->

            </p>
          </template>
          <div>
            <b-col
              cols="12"
              class="
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Anzahl pro Seite"
                @change="handlePageSizeChange"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Suchen..."
                  @keyup="searchOffers"
                >
                </base-input>
              </div>
            </b-col>

            <div class="loader" v-if="loading"></div>

            <el-table
              class="
                table-responsive
                align-items-center
                table-flush table-striped
              "
              header-row-class-name="thead-light"
              :data="offers"
              v-if="offers.length > 0"
            >
              <el-table-column label="Nr." min-width="120px" prop="id" sortable>
              </el-table-column>
              <el-table-column label="Name" min-width="120px" sortable>
                <div slot-scope="{ $index, row }" class="d-flex">
                {{ offers[$index].firstname }} {{ offers[$index].lastname }} {{ offers[$index].company_name }}
                </div>
              </el-table-column>
              <el-table-column
                label="Status"
                min-width="120px"
                sortable
              >
              <div slot-scope="{ $index, row }" class="d-flex">
                {{ written_state(offers[$index].kravag_state) }}
                </div>
              </el-table-column>

              <el-table-column
                label="GEB."
                min-width="100px"
                prop="dob"
                sortable
              >
              </el-table-column>

              <el-table-column label="Fahrz." min-width="200px" sortable>
                <div slot-scope="{ $index, row }" class="d-flex">
                  {{ offers[$index].maker }} {{ offers[$index].car_model_name }}
                </div>
              </el-table-column>

              <el-table-column
                label="KM"
                prop="mileage"
                sortable
              >
              </el-table-column>



              <el-table-column
                label="Erstellt"
                min-width="140px"
                prop="created_at"
                sortable
              >
                <template v-slot="{ row }">
                  <a href="#!" class="font-weight-bold">{{
                    ddsiplay(row.created_at)
                  }}</a>
                </template>
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Optionen">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <a
                    :href="'/#/offers/'+offers[$index].id"
                    class="btn btn-primary btn-sm"
                    @click="showOffer(offers[$index].id)"
                    v-b-tooltip.hover title="Anzeigen"
                    ><i class="fas fa-desktop"></i
                  ></a>
                  <a
                  v-if="(mode == 'Angebote')"
                    :href="'/#/offers/'+offers[$index].id+'/edit'"
                    class="btn btn-warning btn-sm"
                    @click="editOffer(offers[$index].id)"
                    v-b-tooltip.hover title="Bearbeiten"
                    ><i class="fas fa-edit"></i
                  ></a>
                  <a 
                    v-if="(mode == 'Eingereichte Anträge')"
                    :href="'#'"
                    class="btn btn-success btn-sm"
                    @click="retrieveEvb(offers[$index].id)"
                    v-b-tooltip.hover title="EvB"
                    ><i class="fas fa-id-card"></i
                  ></a>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <b-card-footer class="py-4 d-flex justify-content-end">
            <!-- base-pagination v-model="page" :per-page="pageSize" :pageCount="pageCount" @change="handlePageChange"></base-pagination -->

            <base-pagination v-if="mode =='Angebote'"
              class="pagination-no-border"
              :current="page_offer"
              :per-page="pageSize"
              :total="count"
              @change="handlePageChange($event)"
            >
            </base-pagination>
            <base-pagination v-if="mode =='Anträge'"
              class="pagination-no-border"
              :current="page_con"
              :per-page="pageSize"
              :total="count"
              @change="handlePageChange($event)"
            >
            </base-pagination>
            <base-pagination v-if="mode =='Eingereichte Anträge'"
              class="pagination-no-border"
              :current="page_submi"
              :per-page="pageSize"
              :total="count"
              @change="handlePageChange($event)"
            >
            </base-pagination>
          </b-card-footer>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import LightTable from "../Tables/RegularTables/LightTable";
import { TablePlugin } from "bootstrap-vue";
import moment from "moment";

export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    LightTable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      loading: false,
      offers: [],
      count: 0,
      page: 1,
      page_offer: 1,
      page_con: 1,
      page_submi: 1,
      pageSize: 10,
      pageCount: 0,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      mode: 'Angebote',
      searchQuery: "",
      searchedData: [],
    };
  },
  methods: {


    getRequestParams(searchTitle, page, pageSize) {
      let params = {};

      if (searchTitle) {
        params["search"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["per_page"] = pageSize;
      }

      return params;
    },
    ddsiplay(d) {
      return moment(d).format("DD.MM.YYYY");
    },
    retrieveOffers() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page_offer,
        this.pageSize
      );
      this.loading = true;
      this.$api
        .getOffers(params)
        .then((response) => {
          const { offers, count, page, page_count } = response.data;
          this.offers = response.data.offers;
          this.page_offer = response.data.page;
          this.pageCount = response.data.page_count;
          this.count = response.data.count;
          this.pagination.total = response.data.count;

          console.log(this.offers);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.mode = 'Angebote';
          this.loading = false;
        });
    },

    retrieveEvb(token) {
      this.loading = true;
      this.$api
        .createOfferEvb({offer_id: token})
        .then((response) => {
          console.log(token);
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', token+'.pdf');
        link.click()
        URL.revokeObjectURL(link.href)
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    retrieveContracts() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page_con,
        this.pageSize
      );
      this.loading = true;
      this.$api
        .getContracts(params)
        .then((response) => {
          const { offers, count, page, page_count } = response.data;
          this.offers = response.data.offers;
          this.page_con = response.data.page;
          this.pageCount = response.data.page_count;
          this.count = response.data.count;
          this.pagination.total = response.data.count;

          console.log(this.offers);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.mode = 'Anträge';
          this.loading = false;
        });
    },

    retrieveSubmittedContracts() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page_submi,
        this.pageSize
      );
      this.loading = true;
      this.$api
        .getSubmittedContracts(params)
        .then((response) => {
          const { offers, count, page, page_count } = response.data;
          this.offers = response.data.offers;
          this.page_submi = response.data.page;
          this.pageCount = response.data.page_count;
          this.count = response.data.count;
          this.pagination.total = response.data.count;

          console.log(this.offers);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.mode = 'Eingereichte Anträge';
          this.loading = false;
        });
    },

    searchOffers() {
      const params = this.getRequestParams(
        this.searchQuery,
        this.page,
        this.pageSize
      );
      this.loading = true;
      this.$api
        .searchOffers(params)
        .then((response) => {
          const { offers, page, page_count, count } = response.data;
          this.offers = offers;
          (this.page = page), (this.pageCount = page_count);
          this.count = count;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handlePageChange(value) {
      //console.log(value);
      //this.page = value;

      if(this.mode == 'Angebote'){
        this.page_offer = value;
        this.page = this.page_offer;
        this.retrieveOffers();
      }
      if(this.mode == 'Anträge'){
        this.page_con = value;
        this.page = this.page_con;
        retrieveContracts();
      }
      if(this.mode == 'Eingereichte Anträge'){
        this.page_submi = value;
        this.page = this.page_submi;
        this.retrieveSubmittedContracts();
      }
      
    },

    handlePageSizeChange(value) {
      this.pageSize = value;
      this.page = 1;
      this.retrieveOffers();
    },

    showOffer(offerId) {
      console.log("REDIRECTING TO SHOW OFFFER PAGE");
      console.log(`/offers/${offerId}`);

      this.$router.push({ path: `/offers/${offerId}` });
      /* this.$router.push({
        name: "Angebot anzeigen",
        params: { token: `${offerId}`, tab: "Dokumente" },
      });
      */
    },
    editOffer(offerId) {
      this.$router.push({
        name: "Angebot bearbeiten",
        params: { token: `${offerId}` },
      });
    },
    written_state(state){
      console.log(state);
      switch(state) {
        case 'calculated':
          return 'Angebot kalkuliert';
        break;
        case 'consent':
          return 'Angebot angenommen';
        break;
        case 'api_saved':
          return 'Antrag erstellt';
        break;
        case 'printed':
          return 'Antrag gedruckt';
        break;
        case 'submitted':
          return 'Antrag eingereicht';
        break;
        case 'finished':
          return 'Antrag abgeschlossen';
        break;
      } 
    },
  },
  computed: {
    searchRegExp() {
      return new RegExp(`(.*)${this.search}(.*)`);
    },
    rows() {
      return this.offers.length;
    },
  },
  created() {
    this.retrieveOffers();
  },
};
</script>